import urls from '../api_urls/bevolFunction'
import { _post } from '@/axios/request'

// 获取function列表
export function getTableData (params) {
  return _post(urls.GET_LIST, params)
}

// 新增function
export function saveFunction (params) {
  return _post(urls.SAVE_FUNCTION, params)
}

// 获取function详情
export function getFunctionDetail (params) {
  return _post(urls.GET_FUNCTION_DETAIL, params)
}

// 更新function信息
export function updateFunction (params) {
  return _post(urls.UPDATE_FUNCTION, params)
}

// 模糊搜索dlite function信息
export function getDliteFunction (params) {
  return _post(urls.GET_DLITE_FUNCTION, params)
}

// 模糊搜索bevol claim信息
export function getBevolClaim (params) {
  return _post(urls.GET_BEVOL_CLAIM, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/bevolFunction.js